
import Component from 'vue-class-component'
import Vue from 'vue'
import api from '@/api'

@Component
export default class AdminLayoutView extends Vue {
    /**
     * 웹파트 게시 테스트를 위한 테스트 함수
     */
    async handlePublishClicked() {
        try {
            await api.post({
                url: '/common/cacheversion/api/publish',
                data: {
                    comCode: 'HK',
                    ids: ['MENU', 'WEBPARTV3', 'WEBPART_TEMPLATE'],
                },
            });
            (window as any).alertAsync('게시 완료!')
        } catch (err) {
            console.error(err);
            (window as any).alertAsync('게시 실패!')
        }
    }
}
